import { ColorPicker } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceColorPicker",
  mixins: [ColorPicker, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    colorDisabled() {
      return this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
